// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1AppObjectsUpdateSchema = z.object({
  app_objects: z.object({
    objects: z.array(z.object({
      object_id: z.coerce.string().describe("Unique identifier for the app object"),
      etag: z.optional(z.coerce.string().describe("ETag for versioning")),
      name: z.coerce.string().describe("Name of the app object"),
      auto_import: z.boolean().describe("Whether to automatically import this object"),
      project_id: z.optional(z.number().int().describe("Associated Timely project ID")),
    })),
  }),
});
